import { type ReactNode, useId } from "react";

import { ToggleGroup, ToggleGroupItem } from "@/shared/ui/toggle-group";

type FilterOption<V extends string> = { value: V; label: ReactNode };

type FilterGroupProps<V extends string> = {
  label: ReactNode;
  value: V;
  options: readonly FilterOption<V>[];
  onChange: (value: V) => void;
};

// Подпись и «таблетки» одного фильтра под «Ещё фильтры». Всегда выбран один вариант:
// повторное нажатие на выбранный ничего не снимает.
export const FilterGroup = <V extends string>({
  label,
  value,
  options,
  onChange,
}: FilterGroupProps<V>) => {
  const labelId = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <span id={labelId} className="text-xs text-subtle">
        {label}
      </span>
      <ToggleGroup
        type="single"
        variant="pill"
        aria-labelledby={labelId}
        value={value}
        onValueChange={(next) => {
          const option = options.find((candidate) => candidate.value === next);
          if (option !== undefined) {
            onChange(option.value);
          }
        }}
      >
        {options.map((option) => (
          <ToggleGroupItem key={option.value} value={option.value}>
            {option.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
};
